


































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Action, State } from 'vuex-class'
import { RoomItemDetail, BookingDetail } from '../api/hex-interface'
import { getRoomDetail } from '../api/hex'
import ImgViewer from '@/components/ImgView.vue'
/* eslint-disable-next-line */
import Logo from '@/components/svg/LogoBlock.vue'
import DatePicker from '@/components/DatePickers.vue'
import BookingDialog from '@/components/BookingDialog.vue'
const amenitiesImg = require.context('@/assets/amenities')
const amenitiesDict = new Map([
  ['airConditioner', '空調'],
  ['breakfast', '早餐'],
  ['childFriendly', '適合兒童'],
  ['greatView', '漂亮的視野'],
  ['miniBar', 'Mini Bar'],
  ['petFriendly', '寵物攜帶'],
  ['refrigerator', '冰箱'],
  ['roomService', 'Room Service'],
  ['smokeFree', '禁止吸菸'],
  ['sofa', '沙發'],
  ['television', '電視'],
  ['wifi', 'Wi-Fi']
])

@Component({
  components: {
    DatePicker,
    Logo,
    ImgViewer,
    BookingDialog
  }
})
export default class About extends Vue {
  @Prop() id!: string
  @Action('setRoomDetail') setRoomDetail!: (roomDetail: RoomItemDetail) => void
  @Action('setBookingDetail') setBookingDetail!: (bookingDetail: BookingDetail[]) => void
  private bookingDialogIsShow = false
  private isLoading = true
  @State('roomDetail') roomDetail!: RoomItemDetail
  @State('bookingDetail') bookingDetail!: BookingDetail[]
  private imgViewerIsShow = false
  private imgViewerIndex = 0
  private hasError = false

  get roomImg () {
    let result: string[] = []
    if (this.isLoading) return result
    result = this.roomDetail.imageUrl
    return result
  }

  get name () {
    if (this.isLoading) return ''
    return this.roomDetail.name
  }

  get info () {
    if (this.isLoading) {
      return {
        GuestMin: '',
        GuestMax: '',
        Bed: '',
        'Private-Bath': '',
        Footage: ''
      }
    }
    return this.roomDetail.descriptionShort
  }

  get bed () {
    if (this.isLoading) return ''
    return this.roomDetail.descriptionShort.Bed.join(' ,')
  }

  get detail () {
    if (this.isLoading) return ''
    return this.roomDetail.description
  }

  get checkInTime () {
    if (this.isLoading) return ['', '']
    let { checkInEarly, checkInLate } = this.roomDetail.checkInAndOut
    return [checkInEarly, checkInLate]
  }

  get checkOutTime () {
    if (this.isLoading) return ''
    return this.roomDetail.checkInAndOut.checkOut
  }

  get normalDayPrice () {
    if (this.isLoading) return ''
    return this.roomDetail.normalDayPrice
  }
  get holidayPrice () {
    if (this.isLoading) return ''
    return this.roomDetail.holidayPrice
  }

  get disabledDate () {
    if (this.isLoading) return []
    return this.bookingDetail.map(ele => ele.date)
  }

  amenitiesFormat (amenities: {}) {
    return Object.entries(amenities).map(([key, value]) => {
      let k = key === 'Wi-Fi' ? 'wifi' : key.replace('-', '').replace(/^(.)/, x => x[0].toLowerCase())
      if (k === 'smokeFree') value = !value
      return {
        key: k,
        value,
        img: amenitiesImg(`./${k}.svg`),
        tag: amenitiesDict.get(k)
      }
    })
  }

  get amenities () {
    if (this.isLoading) {
      return this.amenitiesFormat({
        'Wi-Fi': false,
        'Breakfast': false,
        'Mini-Bar': false,
        'Room-Service': false,
        'Television': false,
        'Air-Conditioner': false,
        'Refrigerator': false,
        'Sofa': false,
        'Great-View': false,
        'Smoke-Free': false,
        'Child-Friendly': false,
        'Pet-Friendly': false
      })
    }
    return this.amenitiesFormat(this.roomDetail.amenities)
  }

  async mounted () {
    let data = await getRoomDetail(this.id)
    if (data instanceof Error) {
      console.error(data.message)
      this.hasError = true
    } else {
      if (data.success) {
        this.setRoomDetail(data.room[0])
        this.setBookingDetail(data.booking)
        this.isLoading = false
      } else {
        this.hasError = true
        console.log(data)
      }
    }
  }
  imgOnMouseOver (ev: { offsetX: number, offsetY: number, target: HTMLElement }) {
    let dom: HTMLElement = ev.target
    dom.classList.add('scale')
    dom.setAttribute('style', `transform-origin: ${ev.offsetX}px ${ev.offsetY}px`)
  }
  imgOnMouseLeave (ev: { target: HTMLElement }) {
    ev.target.classList.remove('scale')
    ev.target.setAttribute('style', '')
  }
  imgOnClick (imgIndex: number) {
    this.imgViewerIsShow = true
    this.imgViewerIndex = imgIndex
  }
}
